import script from "./ListVehicles.vue?vue&type=script&setup=true&lang=js"
export * from "./ListVehicles.vue?vue&type=script&setup=true&lang=js"

import "./ListVehicles.vue?vue&type=style&index=0&id=f6a96458&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6a96458"]])

export default __exports__